import React from 'react';

const SimpleToggle = ({ options, selected, onChange }) => {
  if (!options || options.length !== 2) return null;

  return (
    <div className="flex items-center justify-center">
      <div className="flex bg-grayExtraLight2 rounded-2xl w-full h-12">
        {options.map((option, index) => (
          <button
            key={option}
            onClick={() => onChange(option)}
            className={`flex-1 font-semibold text-xs tracking-wider transition-colors duration-300 uppercase
              ${index === 0 ? 'rounded-l-xl' : 'rounded-r-xl'}
              ${selected === option ? 'bg-tealExtraLight3 text-white' : 'bg-transparent text-grayExtraLight3'}
            `}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SimpleToggle;
